import React from 'react'
import Typography from '@material-ui/core/Typography';


const OverviewCardViewer = (props) => {
    const { title, description, src } = props
    return (
        <div style={{  padding: '20px', display: 'flex', gap: '12px', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #EEE',}}>
            <img src={src} alt="obligation" style={{ width: title === 'Supplementary Overview' ? '52px' : '77px', height: title === 'Supplementary Overview' ? '53px' : '77px' }} />
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', boxSizing: 'border-box' }}>
                <Typography style={{ fontSize: '16px', fontWeight: '400', color: '#424242', fontStyle: 'normal', lineHeight: '32px' }}>{title}</Typography>
                <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#616161', fontStyle: 'normal', lineHeight: '32px' }}>{description}</Typography>
            </div>
        </div>
    )
}

export default OverviewCardViewer